/**
 * Petits formatages partagés par les pages admin (dates FR, valeurs JSON
 * "brutes" de l'adresse de livraison snapshotée) — évite de dupliquer ces
 * une-lignes dans chaque page admin (commandes, clients, stock…).
 */

/** Date seule, ex. "24/09/2026". `null`/vide → "—". */
export function formatDateFR(value: string | null | undefined): string {
  return value ? new Date(value).toLocaleDateString("fr-FR") : "—";
}

/** Date + heure, ex. "24/09/2026 14:32". `null`/vide → "—". */
export function formatDateTimeFR(value: string | null | undefined): string {
  return value ? new Date(value).toLocaleString("fr-FR") : "—";
}

/**
 * Cf. `jsonField()` de apps/web/app/(admin)/admin/commandes/[id]/page.tsx :
 * l'adresse snapshotée (`AdminOrderShippingAddress`) n'a que des champs
 * `unknown` (jamais garantis au-delà de leur présence) — ce helper les rend
 * lisibles sans jamais planter sur un type inattendu.
 */
export function jsonField(value: unknown): string {
  if (value === null || value === undefined) return "—";
  if (typeof value === "string") return value;
  return JSON.stringify(value);
}
